<template>
  <div>
    <view-wrapper
      :prefix="prefix"
      name="Connector"
      path="connectors"
      :show-cancel="false"
      :save-func="saveConnector"
      :loading="loading"
      :loading-text="loadingText"
      :edit-mode="editing"
      :back-text="'Back to connector list'"
    >
    <wrapper class="mb-5" :check-for-child-focused="true">
        <g-input
          type="text"
          label-placeholder="Connector ip"
          v-model="connector.ipAddress"
          :editable="true"
        />
        <g-input
          type="text"
          label-placeholder="Port"
          v-model="connector.port"
          :editable="true"
        />
        <g-input
          type="text"
          label-placeholder="Protocol"
          v-model="connector.protocol"
          :editable="true"
        />
        <g-input
          type="text"
          label-placeholder="machineName"
          v-model="connector.machineName"
          :editable="true"
        />
        <div class="flex pt-1">
        <Checkbox
          v-model="connector.active"
        />
        <span class="flex self-center pl-5"
          >Use Articles and Labels with this connector</span
        >
      </div>
      </wrapper>
  
      <g-button
        v-if="editing"
        class="mt-2 mb-6 mr-6 big primary white"
        @click="testConnection()"
        >Test connection</g-button>

        <Modal
          v-if="showModal"
          :type="modalType"
          :heading="modalHeader"
          :description="modalDescription"
          @close="hideModal"
        />
        <g-button
        v-if="editing"
        class="mt-2 mb-6 big primary white"
        @click="removeConnector()"
        >Delete</g-button>

        <Modal
          v-if="showModal"
          :type="modalType"
          :heading="modalHeader"
          :description="modalDescription"
          @close="hideModal"
        />
    </view-wrapper>

  </div>
  </template>
  <script>
  import ViewWrapper from "../components/ViewWrapper";
  import Wrapper from "../components/Wrapper";
  import GInput from "../components/forms/Input";
  import GButton from "../components/forms/Button";
  import Checkbox from "../components/forms/Checkbox"
  import Modal from "../components/Modal";

  export default {
    components: {
      ViewWrapper,
      Wrapper,
      GInput,
      GButton,
      Checkbox,
      Modal,
    },
    data: () => ({
      article: {
        name: "",
        articleData: [],
        labels: [],
        assignedLabels: [],
        groups: [],
      },
      connector: {
        ipAddress: "",
        port: 0,
        protocol: "",
        machineName: "",
        data: []
      },
      presetGroups: [],
      loading: false,
      loadingText: "Getting connector",
      articleSaved: false,
      componentKey: 0,
      showModal: false,
    }),
    computed: {
      editing() {
        return this.$route.params.connectorId !== "new";
      },
      prefix() {
        return this.editing ? "Edit" : "Add";
      },
    },
    methods: {
      validateUniqueKeys(event, data) {
        if (event === "") {
          return;
        }
        const existing = this.article.articleData.filter(ad => ad.key === event);
        if (existing.length > 1) {
          data.errors = "Duplicate key value";
        } else {
          data.errors = "";
        }
      },
      async getConnector() {
        this.loadingText = "Getting connector";
        this.loading = true;
        const response = await this.$store.$api.get(
          `/api/connectors/${this.$route.params.connectorId}`
        );
        this.connector = { ...response.data.data };
        this.loading = false;
      },
      async loadPresets() {
        this.loadingText = "Loading presets";
        this.loading = true;
  
        this.article.name = this.$route.query["name"] || "";
  
        this.loading = false;
      },
      queryParamAsArray(name) {
        return typeof this.$route.query[name] == "string"
          ? [this.$route.query[name]]
          : this.$route.query[name] || null;
      },
      hideModal() {
        this.showModal = false;
      },
      async saveConnector() {
        this.loadingText = "Saving connector";
        const payload = {
          ...this.connector
        };
        this.loading = true;
        if (this.editing) {
          payload.id = this.connector.id;
          await this.$store.$api.put(`/api/connectors/`+ this.connector.id, payload);
          this.loading = false;
        } else {
          await this.$store.$api.post("/api/connectors", payload);
          this.loading = false;
        }
      },
      async removeConnector() {
        try {
          await this.$store.$api.delete(`/api/connectors/${this.connector.id}`);
          this.loading = false;
          this.modalType = "success";
          this.modalHeader = "Success";
          this.modalDescription = "The connector is removed";
          this.showModal = true;
          this.$router.push("/connectors/");
        } catch {
          this.loading = false;
          this.modalType = "error";
          this.modalHeader = "Something went wrong";
          this.modalDescription ="Failed to remove the connector.";
          this.showModal = true;
        }
      },
      async testConnection() {
        const payload = {
          ipAddress: this.connector.ipAddress,
          port: this.connector.port,
          protocol: this.connector.protocol,
          machineName: this.connector.machineName
        };

        try {
          await this.$store.$api.post("/api/connectors/validate", payload);
          this.loading = false;
          this.modalType = "success";
          this.modalHeader = "Success";
          this.modalDescription = "The connector is active";
          this.showModal = true;
        } catch {
          this.loading = false;
          this.modalType = "error";
          this.modalHeader = "Something went wrong";
          this.modalDescription ="The connector is unreachable.";
          this.showModal = true;
        }
      },
    },
    async mounted() {
      await this.$store.dispatch("GROUPS/GET_AVAILABLE_GROUPS");
  
      if (this.editing) {
        await this.getConnector();
      } else {
        this.loadPresets();
      }
      this.componentKey++;
    },
  };
  </script>
  